// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.0305 1.88867L23.6874 11.5455L15.3423 19.8906L15.0729 20.1619H19.9993V22.1619L6.74742 22.1619L3.08075 18.4953C1.51865 16.9332 1.51866 14.4005 3.08075 12.8384L14.0305 1.88867ZM5.78786 12.9597L4.49497 14.2526C3.71392 15.0337 3.71392 16.3 4.49497 17.0811L7.57585 20.1619H12.2545L12.6209 19.7928L5.78786 12.9597Z"}}]};

const ClearFormatting1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'clear-formatting-1-filled',
    ref,
    icon: element,
  },
));

ClearFormatting1FilledIcon.displayName = 'ClearFormatting1FilledIcon';

export default ClearFormatting1FilledIcon;
